import _ from 'lodash'
import { getUserLocales } from 'get-user-locale'
import { iso_639_1 as allLangs } from 'iso-639'

export const LANGUAGES = {
    en: allLangs['en'],
    de: allLangs['de'],
    cs: allLangs['cs'],
}

export const LANG_CODES = ['en', 'de', 'cs']

export const DEFAULT_LANG_CODE = 'en'

/**
 * Funkce se snazi zjistit jazyk pro aplikaci po nahrani aplikace
 * Nejdriv se podiva jestli jiz neni ulozen uzivatelsky zvoleny jazyk v local storage.
 * Kdyz neni tak vytahne data z navigator objektu.
 * Cele to pak profiltruje skrz acceptableLanguages a prvni jazyk ktery odpovida nakonec vrati
 * @param {Array} acceptableLanguages
 * @return {String}
 */
export function determineStartupLanguage(acceptableLanguages = [DEFAULT_LANG_CODE]) {
    const languagesToTry = []
    if (_.get(localStorage, 'lang', false)) {
        languagesToTry.push(_.get(localStorage, 'lang'))
    }
    return _.chain(languagesToTry)
        .union(getUserLocales())
        .map(l => _.chain(l)
            .split('-')
            .first()
            .value())
        .filter(l => _.get(acceptableLanguages, l, false))
        .head()
        .defaultTo(DEFAULT_LANG_CODE)
        .value()
}
